import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";

const PersonalTrainingSection = () => (
    <ScrollableAnchor id="personal">
      <section className="content-section bg-primary text-white text-center animatedParent animateOnce" data-sequence='500'>
        <div className="container">
          <div className="content-section-heading text-center">
            <h3 className="text-secondary mb-0">Info</h3>
            <h2 className="mb-5">Personaltraining</h2>
          </div>
          <div className="animated fadeInDownShort" data-id="1">
            <p className="textJustify">Individuell erstellte Trainingspläne, auf deinen Körper und Geist
              Maßgeschneidert. In einem Erstgespräch werden gemeinsam die Ziele und wünsche klar definiert und daraufhin
              gearbeitet. Mit und ohne Biofeedback oder klein Geräte. Was dir in den Sinn kommt, sag es und wir finden
              eine Lösung.</p>
          </div>
        </div>
      </section>
    </ScrollableAnchor>
);

export default PersonalTrainingSection;



// WEBPACK FOOTER //
// ./src/courseinfo/personal.js